import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../../share/src/util/api/polling';
import { SESSION_PROPERTY } from './constants';
import { read } from './read';

/** 
 * 開始処理
 * @param {object} self this インスタンス
 */
export async function standby(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'standby',
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // Session遷移用フラグは、true とする。
      self.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
      // 発生日時読み出し処理に遷移
      await read(self);
    } else {
      // NonDefaultSession遷移が実行済み
      if (!response.data.user_data.is_dispose) {
        self.sessionProperty = SESSION_PROPERTY.NON_DEFAULT;
      }
      // 共通エラー画面へ遷移
      await self.showUnexpectedError();
    }
  } finally {
    self.isLoading = false;
  }
}
